module.exports = __webpack_public_path__ + "img/ball_register3.737d6684.png";